<script setup lang="ts">
import { updates } from '@/data/updates'
import { useAppStore } from '@/stores/appStore'
import { useAuthStore } from '@/stores/authStore'
import { computed } from 'vue'
import { RouterView, useRouter } from 'vue-router'
const appStore = useAppStore()
const authStore = useAuthStore()
const router = useRouter()

const logout = async () => {
  await authStore.logout()
  router.go(0)
}

const latestVersion = computed(() => {
  return updates[0].version
})
</script>

<template>
  <q-layout view="hHh LpR fFf">
    <q-page-container>
      <RouterView />

      <q-dialog v-model="appStore.showDialog" position="bottom">
        <q-card style="width: 350px">
          <q-linear-progress v-if="appStore.errorType" :value="1" color="red" />

          <q-card-section class="row items-center no-wrap">
            <div v-if="appStore.errorType === 'Generic'">
              <div class="text-bold">{{ appStore.errorMessage }}</div>
            </div>
            <div v-if="appStore.errorType === 'Auth'">
              <div class="text-bold">{{ appStore.errorMessage }}</div>
              <q-btn color="accent" label="Logout" @click="logout" />
            </div>
          </q-card-section>
        </q-card>
      </q-dialog>

      <div class="version-text">
        <router-link to="/updates"> v{{ latestVersion }} </router-link>
      </div>
    </q-page-container>
  </q-layout>
</template>

<style scoped>
.version-text {
  position: fixed;
  bottom: 8px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 0.8rem;
  z-index: 9000;
  pointer-events: auto;
}

.version-text a {
  text-decoration: none;
  transition: color 0.2s ease;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  pointer-events: auto;
}

.version-text a:hover {
  color: rgba(255, 255, 255, 0.9);
}
</style>
